export enum Team {
    /** Townsfolk -- Good players who help their team. */
    Townsfolk = "townsfolk",

    /** Outsider -- Good players who harm their team. */
    Outsider = "outsider",

    /** Minions -- Evil players who help their team. */
    Minion = "minion",
    
    /** Demons -- Evil players who don't want to die. */
    Demon = "demon",

    /** Travellers -- Temporary players of either alignment */
    Traveller = "traveller",

    /** Fabled -- Administrative effects to solve a problem */
    Fabled = "fabled",

    /** Loric -- Administrative effects to modify or undermine the game */
    Loric = "loric",
};
